// Nenhum campo do sistema mostra sugestão de autopreenchimento, exceto usuário e senha do login.
// Aplica autocomplete="off" em todo input/textarea/select/form que entrar na página.
const KEEP = new Set(['username', 'current-password']);
const SELECTOR = 'input, textarea, select, form';

function disable(element) {
    const current = element.getAttribute('autocomplete');
    // Só grava quando muda: setAttribute gera nova mutação e o observer entraria em loop.
    if (current !== 'off' && !KEEP.has(current)) {
        element.setAttribute('autocomplete', 'off');
    }
}

function disableWithin(node) {
    if (node.nodeType !== Node.ELEMENT_NODE) {
        return;
    }
    if (node.matches(SELECTOR)) {
        disable(node);
    }
    node.querySelectorAll(SELECTOR).forEach(disable);
}

export function disableAutocomplete() {
    disableWithin(document.body);
    new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'attributes') {
                disableWithin(mutation.target);
            } else {
                mutation.addedNodes.forEach(disableWithin);
            }
        });
    }).observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['autocomplete']});
}
